import { useMemo } from 'react';

/**
 * Get a unique id for a component - often used to link labels and inputs through
 * htmlFor.
 *
 * @param prefix id prefix, no spaces
 * @param override use this instead of the randomly generated id
 */
export function useUniqueId({
  prefix,
  override,
}: {
  prefix: string;
  override?: string;
}): string {
  return useMemo(
    () => override || `${prefix}-${Math.random().toString(16).slice(2)}`,
    [prefix, override]
  );
}
